import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';

import {openModal, changeTypeOfModal} from '../../actions/modals';
import {eventSendPayment} from '../../helpers/analytics';
import {format, addMonths, subDays, addDays} from "date-fns";

import './styles/confirmationBlock.scss';
import {Privileges} from "../CardWhite/Privileges";
import {setPhoneChecked, setPromocode} from "../../actions/card";
import {separate} from "../../helpers/separate";
import PinInput from 'react-pin-input';
import Breadcrumbs from "../Breadcrumbs";

class ConfirmationBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            smsCodeError: false,
            canResendSmsCode: false,
            resendTimeLeft: 59,

            paymentStatus: 'full',
            paymentFormReady: false,
            paymentForm: null,

            promocodeTimer: null,
            promocodeError: false,

            sendLoading: false,

            paymentMethod: null,
            installmentPeriod: 4,
            showPaymentMethodRequiredError: false,

            discountCode: '',
            showCodeNotFound: false,

            timerId: null
        }
    }

    componentDidMount() {
        localStorage.setItem('paymentLink',null);
        localStorage.setItem('orderId', null);
        localStorage.removeItem('cardId');
        localStorage.removeItem('cardTitle')
        localStorage.removeItem('cardPrice')

        if (this.props.resultCard.subscription) {
            this.setState({
                paymentMethod: 'bank_card'
            })
        }

        const timerId = setInterval(() => {
            this.setState({
                resendTimeLeft: this.state.resendTimeLeft - 1
            })

            if (this.state.resendTimeLeft < 1) {
                clearInterval(timerId)

                this.setState({
                    canResendSmsCode: true
                })
            }
        }, 1000)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.canResendSmsCode && !this.state.canResendSmsCode && this.state.resendTimeLeft === 59) {
            const timerId = setInterval(() => {
                this.setState({
                    resendTimeLeft: this.state.resendTimeLeft - 1
                })

                if (this.state.resendTimeLeft < 1) {
                    clearInterval(timerId)

                    this.setState({
                        canResendSmsCode: true
                    })
                }
            }, 1000)
        }
    }

    calculateOneMonth(data) {
        let cost;

        data.cost_month.forEach(item => {
            if (this.props.duration >= item.minMonth && this.props.duration <= item.maxMonth) {
                cost = item.cost;
            }
        })

        if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_price) {
            cost += data.millenium_add_price
        }

        return cost;
    }

    calculateOneMonthFreezing(data) {
        let cost = data.cost_freezing;

        if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_price_freezing) {
            cost += data.millenium_add_price_freezing
        }

        return cost;
    }

    calculateDiscount(data) {
        let discount;

        data.forEach(item => {
            if (this.props.duration >= item.minMonth && this.props.duration <= item.maxMonth) {
                discount = item.discount;
            }
        })

        return discount;
    }

    basePrice(data) {
        if (this.props.resultCard.subscription) {
            let totalCost = data.subscription_cost_first_month
            if (!this.props.resultCard.clubs.millenium && this.props.milleniumAdded && data.millenium_add_first_month_price) {
                totalCost += data.millenium_add_first_month_price
            }
            return totalCost
        } else if (this.props.resultCard.test_drive) {
            return this.props.resultCard.cost_fixed
        } else if (data.cost_fixed && data.visit_count_fixed) {
            return (data.cost_fixed + (this.props.milleniumAdded ? data.millenium_add_fixed_price : 0)) * data.visit_count_fixed;
        } else {
            let monthCost = +this.calculateOneMonth(data) * this.props.duration;
            let freezingCost = +this.calculateOneMonthFreezing(data) * this.props.freezing;
            let totalCost = monthCost + freezingCost

            if (this.props.resultCard.family) {
                if (!this.checkMinAge(this.props.customerData.secondBirthDate, 18)) {
                    let teenCardData = {
                        cost_month: [{
                            cost: data.teen_card_cost_month,
                            maxMonth: 999,
                            minMonth: 0
                        }],
                        millenium_add_price: data.teen_card_club_add_cost_month,
                        cost_freezing: data.teen_card_cost_freezing,
                        millenium_add_price_freezing: data.teen_card_club_add_cost_freezing
                    }

                    totalCost = totalCost
                      + this.calculateOneMonth(teenCardData) * data.teen_card_base_months
                      + this.calculateOneMonthFreezing(teenCardData) * data.teen_card_base_freezing_months
                } else {
                    totalCost = totalCost * 2
                }
            }

            return totalCost;
        }
    }

    totalDiscount(data, promocode) {
        return this.basePrice(data) - this.finalPrice(data, promocode)
    }

    finalPrice(data, promocode) {
        let basePrice = this.basePrice(data),
            result = basePrice;

        if (!this.props.resultCard.subscription && !this.props.resultCard.test_drive) {
            if (this.props.gameleadDiscount) {
                result -= result * parseInt(this.props.gameleadDiscount) / 100
            } else if (this.props.widgetDiscount) {
                result -= result * parseInt(this.props.widgetDiscount) / 100
            } else {
                if (this.props.resultCard.unconditional_discount && (!this.props.prolongation || !this.props.resultCard.prolongation_discount)) {
                    result -= result * this.props.resultCard.unconditional_discount / 100
                }

                if (this.props.studentStatus) {
                    result -= result * this.calculateDiscount(this.props.mainData.discounts.student) / 100
                } else if (this.props.dayDiscount) {
                    result -= result * this.calculateDiscount(this.props.mainData.discounts.day) / 100
                }

                if (this.props.prolongation
                  && this.props.resultCard.prolongation_discount
                  && this.props.prolongationDiscount > 0
                  && this.props.duration > 1
                  && !(this.props.studentStatus && data.student_discount > 0)
                ) {
                    result -= result * this.props.prolongationDiscount / 100
                }
            }
        }

        if (this.props.gameleadDiscount == 0 && this.props.widgetDiscount == 0 && promocode) {
            if (promocode.discount > 100) {
                result -= promocode.discount;
            } else {
                result -= result * promocode.discount / 100;
            }
        }

        return result
    }

    appliedDiscounts(data, promocode) {
        let price = this.basePrice(data),
          result = [],
          discount = 0

        if (!this.props.resultCard.subscription && !this.props.resultCard.test_drive) {
            if (this.props.gameleadDiscount) {
                discount = price * parseInt(this.props.gameleadDiscount) / 100
                result.push(['Скидка из колеса фортуны', discount])
                price -= discount
            } else if (this.props.widgetDiscount) {
                discount = price * parseInt(this.props.widgetDiscount) / 100
                result.push(['Скидка из виджета', discount])
                price -= discount
            } else {
                if (this.props.resultCard.unconditional_discount && (!this.props.prolongation || !this.props.resultCard.prolongation_discount)) {
                    discount = price * this.props.resultCard.unconditional_discount / 100
                    result.push(['Скидка при покупке онлайн', discount])
                    price -= discount
                }

                if (this.props.studentStatus && data.student_discount > 0) {
                    discount = price * this.calculateDiscount(this.props.mainData.discounts.student) / 100
                    result.push(['Скидка студентам', discount])
                    price -= discount
                } else if (this.props.dayDiscount) {
                    discount = price * this.calculateDiscount(this.props.mainData.discounts.day) / 100
                    result.push(['Дневная скидка', discount])
                    price -= discount
                }

                if (this.props.prolongation
                  && this.props.resultCard.prolongation_discount
                  && this.props.prolongationDiscount > 0
                  && this.props.duration > 1
                  && !(this.props.studentStatus && data.student_discount > 0)
                ) {
                    discount = price * this.props.prolongationDiscount / 100
                    result.push(['Скидка за продление', discount])
                    price -= discount
                }
            }
        }

        if (this.props.gameleadDiscount == 0 && this.props.widgetDiscount == 0 && promocode) {
            if (promocode.discount > 100) {
                result.push(['Скидка по промокоду', promocode.discount])
            } else {

                result.push(['Скидка по промокоду', price * promocode.discount / 100])
            }
        }

        return result
    }

    goToPrevScreen() {
        this.props.backStep(this.props.step - 1);
    }

    finishDate() {
        return this.props.resultCard.subscription
          ? addDays(this.props.customerData.activationDate, 29)
          : subDays(addMonths(this.props.customerData.activationDate, this.props.duration + this.props.freezing), 1);
    }

    nextChargeDate() {
        return addDays(this.props.customerData.activationDate, 26);
    }

    secondTotalDuration () {
        return this.calculateAge(this.props.customerData.secondBirthDate) < 18 ?
          this.props.resultCard.teen_card_base_months + this.props.resultCard.teen_card_base_freezing_months :
          this.totalDuration()
    }

    secondFinishDate() {
        return subDays(addMonths(this.props.customerData.secondActivationDate, this.secondTotalDuration()), 1);
    }

    checkPromocode(code) {
        if (code == '') {
            this.props.setPromocode(null)
            return;
        }

        let self = this,
            data = {
                phone: this.props.customerData.phone,
                code: code,
                card: this.props.resultCard.title,
                prolongation: this.props.prolongation && this.props.resultCard.prolongation_discount && this.props.prolongationDiscount > 0,
                family: this.props.resultCard.family,
                student: this.props.studentStatus,
                day: this.props.dayDiscount,
                referalDiscount: this.props.resultCard.referal_discount,
                baseMonths: this.props.resultCard.base_months
            }

        self.setState({
            sendLoading: true,
            showCodeNotFound: false
        });

        axios.post(`${process.env.REACT_APP_API_SITE}/check-promocode`, data, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (response.data.error) {
                    self.setState({
                        sendLoading: false,
                    });
                    //self.props.history.push('/finish?result=error');
                    return false;
                }

                if (response.data) {
                    self.setState({
                        sendLoading: false,
                    });

                    if (response.data.available) {
                        self.props.setPromocode({
                            'code': code,
                            'discount': response.data.discount,
                            'present': response.data.present
                        })
                    } else {
                        self.props.setPromocode(null)
                        self.setState({showCodeNotFound: true})
                    }
                }
            }
        }).catch(function (error) {
            // console.log('error', error.response);
            self.setState({
                sendLoading: false,
            });
        });
    }

    clearPromocode() {
        if (window.confirm('Отменить промокод?')) {
            this.setDiscountCode('')
            this.props.setPromocode(null)
        }
    }

    setDiscountCode(code) {
        this.setState({discountCode: code, showCodeNotFound: false})
    }

    calculateAge(birthDateString) {
        let birthDateArr = birthDateString.split('.'),
          birthDate = new Date(birthDateArr[2], birthDateArr[1]-1, birthDateArr[0]),
          nowDate = new Date()

        return (nowDate - birthDate)/1000/60/60/24/365.2425
    }

    checkMinAge(birthDateString, minAge) {
        return this.calculateAge(birthDateString) >= minAge
    }

    checkSmsCode(code) {
        if (code.length < 4) {
            return;
        }

        let self = this,
          data = {
              phone: this.props.customerData.phone,
              code: code
          }

        self.setState({
            sendLoading: true
        });

        axios.post(`${process.env.REACT_APP_FITRON_URL}/check-sms-code`, data, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (response.data.error) {
                    self.setState({
                        sendLoading: false,
                    });
                    //self.props.history.push('/finish?result=error');
                    return false;
                }

                if (response.data) {
                    self.setState({
                        sendLoading: false,
                    });

                    if (response.data.correct) {
                        self.props.setPhoneChecked({
                            'status': true,
                            'phone': self.props.customerData.phone
                        })

                        self.props.history.push('/order/' + self.props.orderCode);
                    } else {
                        self.props.setPhoneChecked({
                            'status': false,
                            'phone': ''
                        })
                        self.setState({smsCodeError: true})
                    }
                }
            }
        }).catch(function (error) {
            // console.log('error', error.response);
            self.setState({
                sendLoading: false,
            });
        });
    }

    resendSmsCode() {
        if (!this.state.canResendSmsCode || this.state.resendTimeLeft > 0) {
            return;
        }

        let self = this,
          data = {
              phone: this.props.customerData.phone
          }

        self.setState({
            sendLoading: true
        });

        axios.post(`${process.env.REACT_APP_FITRON_URL}/resend-sms-code`, data, {
            headers: {
                'Content-type': 'application/json',
            }
        }).then((response) => {
            // console.log('response', response);
            if (response.status === 200) {
                if (response.data.error) {
                    self.setState({
                        sendLoading: false,
                    });
                    //self.props.history.push('/finish?result=error');
                    return false;
                }

                if (response.data) {
                    self.setState({
                        sendLoading: false,
                        canResendSmsCode: false,
                        resendTimeLeft: 59
                    });
                }
            }
        }).catch(function (error) {
            // console.log('error', error.response);
            self.setState({
                sendLoading: false,
            });
        });
    }

    render() {

        const {
            resultCard,
            custom,
            customerData,
            duration,
            freezing,
            dayDiscount,
            studentStatus,
            prolongation,
            promocode,
            milleniumAdded,
            gameleadDiscount,
            widgetDiscount,
            mainData
        } = this.props;

        const hasDiscount = dayDiscount || studentStatus || (prolongation && this.props.resultCard.prolongation_discount) || promocode || gameleadDiscount || widgetDiscount || this.props.resultCard.unconditional_discount

        return (
            <div>
                <div className="container">
                    <div className="confirmation">
                        <Breadcrumbs currentItem={2} goBackHandle={this.goToPrevScreen.bind(this)} />
                        <div className="confirmation__body">
                            <div className="confirmation__body__info">
                                <div className="confirmation__body__info__confirmation">
                                    <h2>Введите код из СМС</h2>
                                    <p className="sent-to-phone">Отправили на {customerData.phone}</p>
                                    <p><button className="change-phone" onClick={this.goToPrevScreen.bind(this)}>Изменить номер</button></p>

                                    <PinInput
                                      length={4}
                                      initialValue=""
                                      onChange={(value, index) => {
                                          this.setState({smsCodeError: false})
                                      }}
                                      type="numeric"
                                      inputMode="number"
                                      inputStyle={{
                                          borderColor: '#394359',
                                          //width: '112px',
                                          //height: '112px',
                                          margin: 0,
                                          color: '#ffffff',
                                          fontSize: '48px',
                                          lineHeight: '32px',
                                          fontWeight: '700',
                                          borderRadius: '4px'
                                      }}
                                      inputFocusStyle={{borderColor: '#DADEE8'}}
                                      onComplete={(value, index) => {
                                          this.checkSmsCode(value)
                                      }}
                                      autoSelect={true}
                                      focus={true}
                                      regexCriteria={/^[0-9]*$/}
                                    />

                                    <p className="code-error" style={{opacity: this.state.smsCodeError ? 1 : 0}}>Неверный код. Попробуйте еще раз.</p>

                                    {
                                        this.state.canResendSmsCode ?
                                          <button className="request-code-again" onClick={() => this.resendSmsCode()}>Запросить код повторно</button> :
                                          <p className="timeout-info">Запросить код повторно можно будет через 00:{this.state.resendTimeLeft < 10 ? 0 : ''}{this.state.resendTimeLeft}</p>
                                    }
                                </div>

                                <div className="confirmation__body__info__header">
                                    <h2>Ваш контракт</h2>
                                    {
                                        custom ?
                                          <div className="title">
                                              {duration} месяц{duration > 4 ? 'ев' : (duration > 1 ? 'а' : '')} фитнеса
                                              {freezing ? <span> + {freezing * 30} дней заморозки</span> : ''}</div>
                                          : <div className={'title ' + resultCard.header_class}
                                                 dangerouslySetInnerHTML={{__html: resultCard.title}}></div>
                                    }
                                </div>

                                <div className="confirmation__body__info__body" ref={(ref) => this.ref = ref}>
                                    <div className="specification">
                                        <div className="clubs">
                                            <div>
                                                <p className="title">Клубы</p>
                                                {
                                                    resultCard.clubs.gazetniy ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Газетный</b> / Красноармейская, 170</p>
                                                      : ''
                                                }
                                                {
                                                    resultCard.clubs.gorizont ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Горизонт</b> / пр. М. Нагибина, 32e</p>
                                                      : ''
                                                }
                                                {
                                                    resultCard.clubs.orbita ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Орбита</b> / Королева, 10/4</p>
                                                      : ''
                                                }
                                                {
                                                    resultCard.clubs.millenium || milleniumAdded ?
                                                      <p><img
                                                        src={require("../../static/images/icons/check-blue.svg").default}/>
                                                          <b>Миллениум</b> / Соборный, 94 г</p>
                                                      : ''
                                                }
                                            </div>
                                        </div>
                                        {
                                            resultCard.subscription ?
                                              <div className="duration">
                                                  Срок действия контракта 30
                                                  дней, <b>с&nbsp;{format(customerData.activationDate, 'dd.MM.yyyy')} по {format(this.finishDate(), 'dd.MM.yyyy')}</b>
                                                  <br/><b>Автоматическое продление.<br/>Следующий платёж будет списан {format(this.nextChargeDate(), 'dd.MM.yyyy')}</b></div> :
                                              <div>
                                                  <div className="duration">
                                                      {
                                                          resultCard.test_drive ?
                                                            <p>1 день фитнеса</p> :
                                                            (
                                                              resultCard.visit_count_fixed ?
                                                                <span>{separate(Math.round(resultCard.visit_count_fixed))} посещени{String(resultCard.visit_count_fixed).endsWith(1) ? 'е' : ('234'.includes(String(resultCard.visit_count_fixed).substr(-1, 1)) ? 'я' : 'й')} активного фитнеса в течение года</span>
                                                                :
                                                                <p>{duration} месяц{duration > 4 ? 'ев' : (duration > 1 ? 'а' : '')} активного фитнеса</p>
                                                            )
                                                      }
                                                      {freezing ? <p>+ {freezing * 30} дней заморозки</p> : ''}
                                                  </div>
                                                  {
                                                      resultCard.family ?
                                                        <div className="duration">
                                                            <h2>Контракт №2</h2>
                                                            {
                                                                this.calculateAge(customerData.secondBirthDate) < 18 ?
                                                                  <div>
                                                                      <p>{resultCard.teen_card_base_months} месяц{resultCard.teen_card_base_months > 4 ? 'ев' : (resultCard.teen_card_base_months > 1 ? 'а' : '')} активного
                                                                          фитнеса</p>
                                                                      {resultCard.teen_card_base_freezing_months ?
                                                                        <p>+ {resultCard.teen_card_base_freezing_months * 30} дней
                                                                            заморозки</p> : ''}
                                                                  </div> :
                                                                  <div>
                                                                      <p>{duration} месяц{duration > 4 ? 'ев' : (duration > 1 ? 'а' : '')} активного
                                                                          фитнеса</p>
                                                                      {freezing ?
                                                                        <p>+ {freezing * 30} дней заморозки</p> : ''}
                                                                  </div>
                                                            }
                                                        </div>
                                                        : ''
                                                  }
                                                  {resultCard.comfort ? <p className='comfort-tip'>
                                                      <b>Время посещения ограничено</b>
                                                      <br/><br/>Доступ в клуб в будние дни:
                                                      <ul style={{paddingLeft: '15px', marginTop: '5px'}}>
                                                          <li>с 7:00 до 17:00 (FITRON Газетный с 6:00 до 17:00)</li>
                                                          <li>с 21:00 до 23:00</li>
                                                      </ul>
                                                      <br/>Выходные и праздничные дни без ограничений
                                                  </p> : ''}
                                                  {resultCard.youth ? <p className='comfort-tip'>
                                                      <b>Только для клиентов возрастом от 15 до 18 лет</b>
                                                      <br/><br/><b>Время посещения ограничено</b>
                                                      <br/>Доступ в клуб с 7:00 до 17:00
                                                      <br/>(FITRON Газетный с 6:00 до 17:00)
                                                  </p> : ''}
                                                  {
                                                      resultCard.test_drive || !customerData.activationDate ? '' :
                                                        <div className="period">
                                                            <div>Период действия
                                                                контракта{resultCard.family ? ' №1' : ''}</div>
                                                            <div>
                                                                <b
                                                                  className="period">с {format(customerData.activationDate, 'dd.MM.yyyy')} по {format(this.finishDate(), 'dd.MM.yyyy')}</b>
                                                            </div>
                                                            {
                                                                resultCard.family ?
                                                                  <div>
                                                                      <div>Период действия контракта №2</div>
                                                                      <div>
                                                                          <b
                                                                            className="period">с {format(customerData.secondActivationDate, 'dd.MM.yyyy')} по {format(this.secondFinishDate(), 'dd.MM.yyyy')}</b>
                                                                      </div>
                                                                      <div className="attention">Для завершения оформления
                                                                          контрактов и подтверждения личности вам необходимо прийти с оригиналами
                                                                          паспортов в отдел продаж выбранного клуба. При оформлении
                                                                          контракта на ребенка до 14 лет, необходимо иметь с собой
                                                                          оригинал свидетельства о рождении
                                                                      </div>
                                                                  </div> :
                                                                  <div className="attention">Для завершения оформления контракта и подтверждения личности вам необходимо прийти с оригиналом паспорта в отдел продаж выбранного клуба</div>
                                                            }
                                                        </div>
                                                  }
                                              </div>
                                        }
                                        {
                                            /*
                                            resultCard.title == 'Ultra' ?
                                              <div className="period">
                                                  <div className="attention">При покупке карты Ultra по промокоду AQUA
                                                      вы также получаете доступ в новую аквазону FITRON Millenium.
                                                      Доступ предоставляется на месяц с момента открытия аквазоны
                                                  </div>
                                              </div>
                                              : ''
                                             */
                                        }
                                    </div>

                                    <Privileges
                                      privileges={resultCard.privileges}
                                      milleniumAdded={milleniumAdded || resultCard.clubs.millenium}
                                      millenium_privileges={resultCard.millenium_privileges}
                                      towel={resultCard.test_drive && resultCard.includes.towel}
                                      testDrive={resultCard.test_drive}
                                      family={resultCard.family}
                                      subscription={resultCard.subscription}
                                    ></Privileges>

                                    <div className="customer-info">
                                        <h3>Данные владельца контракта</h3>
                                        <p>{customerData.name}</p>
                                        <p>{customerData.phone}</p>
                                        <p>{customerData.email}</p>
                                        <p>{customerData.birthDate}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="confirmation__body__pay">
                                {
                                    !resultCard.has_promocode || gameleadDiscount || widgetDiscount ? '' :
                                      <div className="clientForm__item">
                                          {promocode ?
                                            <div className="promocode-cont promocode-applied">
                                                <input type="text" className="promo-code"
                                                       disabled="disabled"
                                                       value={promocode.code}/>
                                                <button onClick={e => {
                                                    e.preventDefault()
                                                    this.clearPromocode()
                                                }} className="button-clear">
                                                    <img
                                                      src={require('../../static/images/icons/close.svg').default}
                                                      alt=""/>
                                                </button>
                                            </div>
                                            :
                                            <div className="promocode-cont">
                                                <input type="text" className="promo-code"
                                                       disabled={this.state.sendLoading}
                                                       placeholder="Промокод"
                                                       value={this.state.discountCode}
                                                       onChange={e => {
                                                           this.setDiscountCode(e.target.value)
                                                       }}
                                                  /*
                                                  onBlur={
                                                      e => {
                                                          this.checkPromocode(e.target.value)
                                                      }}
                                                   */
                                                       onKeyUp={
                                                           e => {
                                                               if (e.code === 'Enter') {
                                                                   e.preventDefault()
                                                                   this.checkPromocode(e.target.value)
                                                               }
                                                           }
                                                       }
                                                />
                                                <button
                                                  disabled={this.state.sendLoading}
                                                  onClick={e => {
                                                      e.preventDefault()
                                                      this.checkPromocode(this.state.discountCode)
                                                  }} className={this.state.discountCode.length > 1 ? 'active' : ''}
                                                >
                                                    <img
                                                      src={require('../../static/images/icons/yes-icon-color.svg').default}
                                                      alt=""/>
                                                </button>
                                            </div>
                                          }
                                          {this.state.showCodeNotFound ?
                                            <div className="promocode-not-found">Промокод не действителен</div> : ''}
                                      </div>
                                }
                                {
                                    resultCard.slug == 'sale'
                                      ? ''
                                      : <table className="cost">
                                          <tbody>
                                          <tr>
                                              <td>{resultCard.family ? '2 товара' : '1 товар'}</td>
                                              <td>{separate(this.basePrice(resultCard))} ₽</td>
                                          </tr>
                                          {
                                              hasDiscount && this.totalDiscount(resultCard, promocode) > 0 ?
                                                this.appliedDiscounts(resultCard, promocode).map(discount => <tr
                                                  className="discount">
                                                    <td>{discount[0]}</td>
                                                    <td>{separate(discount[1])} ₽</td>
                                                </tr>)
                                                : ''
                                          }
                                          {
                                              hasDiscount && promocode && promocode.present ?
                                                <tr className="confirmation__body__pay__present">
                                                    <td>Подарок:</td>
                                                    <td>{promocode.present}</td>
                                                </tr>
                                                : ''
                                          }
                                          </tbody>
                                      </table>
                                }
                                <div className="total">
                                    <div className="title" dangerouslySetInnerHTML={{__html: resultCard.subscription ? 'Новый период' : 'Итоговая<br/>цена'}}></div>
                                    <div className="amount">
                                        {separate(Math.ceil(this.finalPrice(resultCard, promocode)))} ₽
                                    </div>
                                </div>
                                {
                                    resultCard.subscription ?
                                      <div className="total-subscription">
                                          <div className="title">Продление</div>
                                          <div className="amount">
                                              {separate(Math.ceil(resultCard.cost_month_base + (milleniumAdded ? resultCard.millenium_add_price : 0)))} ₽
                                          </div>
                                      </div> : ''
                                }
                                <div
                                  className={'methods' + (this.state.showPaymentMethodRequiredError ? ' error' : '')}>
                                    <p className="title">Способ оплаты</p>

                                    <div className="methods-list">
                                        <div
                                          className={'by-card' + (this.state.paymentMethod == 'bank_card' ? ' selected' : '')}
                                          onClick={() => {
                                              this.setState({
                                                  paymentMethod: 'bank_card',
                                                  showPaymentMethodRequiredError: false
                                              })
                                          }}
                                        >
                                            <span className="checkbox"></span>
                                            <span className="label">Картой</span>
                                            <img src={require('../../static/images/icons/pay-by-card.svg').default}  alt="" />
                                        </div>
                                        {
                                            resultCard.subscription ? '' :
                                                <div className={'sbp' + (this.state.paymentMethod == 'sbp' ? ' selected' : '')}
                                                     onClick={() => {
                                                         this.setState({
                                                             paymentMethod: 'sbp',
                                                             showPaymentMethodRequiredError: false
                                                         })
                                                     }}
                                                >
                                                    <span className="checkbox"></span>
                                                    <span className="label">СБП</span>
                                                    <img src={require('../../static/images/icons/sbp.svg').default} alt=""/>
                                                </div>
                                        }
                                        {
                                            resultCard.subscription ? '' :
                                                <div
                                                  className={'sberpay' + (this.state.paymentMethod == 'sberbank' ? ' selected' : '')}
                                                  onClick={() => {
                                                      this.setState({
                                                          paymentMethod: 'sberbank',
                                                          showPaymentMethodRequiredError: false
                                                      })
                                                  }}
                                                >
                                                    <span className="checkbox"></span>
                                                    <span className="label">SberPay</span>
                                                    <img src={require('../../static/images/icons/sberpay.png')} alt=""/>
                                                </div>
                                        }
                                        {
                                            /*
                                            resultCard.subscription ? '' :
                                                <div
                                                  className={'tinkoff_installments' + (this.state.paymentMethod == 'tinkoff' ? ' selected' : '')}
                                                  onClick={() => {
                                                      this.setState({
                                                          paymentMethod: 'tinkoff',
                                                          showPaymentMethodRequiredError: false
                                                      })
                                                  }}
                                                >
                                                    <span className="checkbox"></span>
                                                    <span className="label">Тинькофф</span>
                                                    <img src={require('../../static/images/icons/tinkoff-logo.svg').default} alt=""/>
                                                </div>
                                             */
                                        }
                                        {
                                            /*
                                            duration >= 9 && this.finalPrice(resultCard, promocode) > 3000 ?
                                              <div
                                                className={'installments' + (this.state.paymentMethod == 'sber_loan' ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({
                                                        paymentMethod: 'sber_loan',
                                                        showPaymentMethodRequiredError: false
                                                    })
                                                }}
                                              >
                                                  <span className="checkbox"></span>
                                                  <span className="label">Рассрочка</span>
                                                  <img src={require('../../static/images/icons/sberbank-logo.svg').default} alt=""/>
                                              </div> : ''
                                             */
                                        }
                                        {
                                            resultCard.tinkoff_loan_available ?
                                              <div
                                                className={'tinkoff_installments' + (this.state.paymentMethod == 'tinkoff_loan' ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({
                                                        paymentMethod: 'tinkoff_loan',
                                                        showPaymentMethodRequiredError: false
                                                    })
                                                }}
                                              >
                                                  <span className="checkbox"></span>
                                                  <span className="label">Рассрочка</span>
                                                  <img src={require('../../static/images/icons/tinkoff-logo.svg').default} alt=""/>
                                              </div> : ''
                                        }
                                        {
                                            resultCard.tinkoff_credit_available ?
                                              <div
                                                className={'tinkoff_installments' + (this.state.paymentMethod == 'tinkoff_credit' ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({
                                                        paymentMethod: 'tinkoff_credit',
                                                        showPaymentMethodRequiredError: false
                                                    })
                                                }}
                                              >
                                                  <span className="checkbox"></span>
                                                  <span className="label">Кредит</span>
                                                  <img src={require('../../static/images/icons/tinkoff-logo.svg').default} alt=""/>
                                              </div> : ''
                                        }
                                        {
                                            resultCard.dolyame_available ?
                                              <div
                                                className={'dolyame' + (this.state.paymentMethod == 'dolyame' ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({
                                                        paymentMethod: 'dolyame',
                                                        showPaymentMethodRequiredError: false
                                                    })
                                                }}
                                              >
                                                  <span className="checkbox"></span>
                                                  <span className="label">Долями</span>
                                                  <img src={require('../../static/images/icons/dolyame-logo.svg').default} alt=""/>
                                              </div> : ''
                                        }
                                    </div>

                                    {
                                        this.state.paymentMethod == 'tinkoff_loan' ?
                                          <div className="methods-list periods">
                                              <div className={this.state.installmentPeriod == 4 ? 'selected' : ''}
                                                   onClick={() => {
                                                       this.setState({
                                                           installmentPeriod: 4,
                                                           showPaymentMethodRequiredError: false
                                                       })
                                                   }}
                                              >
                                                  <b>4 мес</b>
                                                  <hr/>
                                                  <b>{separate(Math.ceil(this.finalPrice(resultCard, promocode) / 4))}</b>
                                                  <br/>₽/мес
                                              </div>
                                              <div className={this.state.installmentPeriod == 6 ? 'selected' : ''}
                                                   onClick={() => {
                                                       this.setState({
                                                           installmentPeriod: 6,
                                                           showPaymentMethodRequiredError: false
                                                       })
                                                   }}
                                              >
                                                  <b>6 мес</b>
                                                  <hr/>
                                                  <b>{separate(Math.ceil(this.finalPrice(resultCard, promocode) / 6))}</b>
                                                  <br/>₽/мес
                                              </div>
                                              <div className={this.state.installmentPeriod == 10 ? 'selected' : ''}
                                                   onClick={() => {
                                                       this.setState({
                                                           installmentPeriod: 10,
                                                           showPaymentMethodRequiredError: false
                                                       })
                                                   }}
                                              >
                                                  <b>10 мес</b>
                                                  <hr/>
                                                  <b>{separate(Math.ceil(this.finalPrice(resultCard, promocode) / 10))}</b>
                                                  <br/>₽/мес
                                              </div>
                                              <div className={this.state.installmentPeriod == 12 ? 'selected' : ''}
                                                   onClick={() => {
                                                       this.setState({
                                                           installmentPeriod: 12,
                                                           showPaymentMethodRequiredError: false
                                                       })
                                                   }}
                                              >
                                                  <b>12 мес</b>
                                                  <hr/>
                                                  <b>{separate(Math.ceil(this.finalPrice(resultCard, promocode) / 12))}</b>
                                                  <br/>₽/мес
                                              </div>
                                          </div>
                                          : ''
                                    }

                                    <p className="methods-error">{this.state.showPaymentMethodRequiredError ? 'Выберите способ оплаты' : ''}&nbsp;</p>
                                </div>

                                <button
                                  type="button"
                                  className={this.state.sendLoading ? '_loading' : ''}
                                  disabled={true}
                                >
                                    <span>Оплатить</span>
                                </button>

                                <p className="comment">Вы будете перенаправлены на страницу банка</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mainData: state.card.mainData,
        resultCard: state.card.resultCard,
        prolongation: state.card.prolongation,
        prolongationDiscount: state.card.prolongationDiscount,
        studentStatus: state.card.studentStatus,
        dayDiscount: state.card.dayDiscount,
        clubOferta: state.card.clubOferta,
        customerData: state.card.customerData,
        custom: state.card.custom,
        duration: state.card.duration,
        freezing: state.card.freezing,
        promocode: state.card.promocode,
        milleniumAdded: state.card.milleniumAdded && state.card.resultCard.millenium_add_available,
        gameleadDiscount: state.card.gameleadDiscount,
        widgetDiscount: state.card.widgetDiscount,
        orderCode: state.card.orderCode
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    openModal,
    changeTypeOfModal,
    setPromocode,
    setPhoneChecked
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationBlock);